/* Patagonia Café — mobile harmonisation (max-width 749px only). Everything is restored above that width. */
(() => {
  'use strict';
  const media = window.matchMedia('(max-width: 749px)');
  const labelsNode = document.getElementById('pc-mobile-labels');
  let copy = {};
  try { copy = labelsNode ? JSON.parse(labelsNode.textContent) : {}; } catch (error) {}
  const coffees = '.pc-solandino,.pc-signature,.pc-ouro,.pc-espresso,.pc-bresil-specialite,.pc-colombia,.pc-honduras';
  const wrappers = new Map();
  function fold(node, label, nested) {
    if (!node || !label || wrappers.has(node) || (!nested && node.closest('.pc-mobile-disclosure'))) return;
    const marker = document.createComment('pc-mobile-harmony-position');
    const details = document.createElement('details');
    details.className = 'pc-mobile-disclosure pc-mobile-harmony-fold';
    const summary = document.createElement('summary');
    summary.textContent = label;
    const body = document.createElement('div');
    body.className = 'pc-mobile-disclosure__body';
    node.before(marker, details);
    details.append(summary, body);
    body.append(node);
    wrappers.set(node, { marker, details });
  }
  function inline(details) {
    details.open = true;
    details.classList.add('pc-harmony-inline');
  }
  function restore() {
    wrappers.forEach(({ marker, details }, node) => { marker.replaceWith(node); details.remove(); });
    wrappers.clear();
  }
  function apply() {
    if (!media.matches) { restore(); return; }
    document.querySelectorAll(coffees).forEach(root => {
      root.querySelectorAll(':scope > .taste').forEach(node => fold(node, copy.tasting || 'Les détails de dégustation'));
    });
    const description = document.querySelector('.product__info-container .product__description');
    if (description && document.querySelector('.pcf-strip')) fold(description, copy.description || 'En savoir plus sur ce café');
    /* Key information stays visible: character block on coffee pages, origin and aromas on the coffee list. */
    document.querySelectorAll(coffees).forEach(root => {
      root.querySelectorAll(':scope > .pc-mobile-disclosure').forEach(details => {
        if (details.querySelector(':scope > .pc-mobile-disclosure__body > .love, :scope > .pc-mobile-disclosure__body > .origin')) inline(details);
      });
      root.querySelectorAll('.origin .origin-media, .origin .media').forEach(node => {
        if (!node.closest('.pc-mobile-harmony-fold')) fold(node, copy.workshop || 'Notre torréfaction artisanale', true);
      });
    });
    document.documentElement.classList.add('pc-mobile-harmony');
  }
  function openFromHash() {
    if (!media.matches || !location.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (error) { return; }
    let details = target && target.closest('.pc-mobile-harmony-fold');
    while (details) { details.open = true; details = details.parentElement.closest('.pc-mobile-disclosure'); }
  }
  function init() { apply(); openFromHash(); }
  media.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();

